import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { BounceLoader as BounceLoader$2, Dot } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Renders a BounceLoader component.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {'s'|'m'} [props.size='m'] - The size of the Bounce Loader.
 * @param {Object} [props.rest] - Additional properties.
 *
 * @returns {import('react').JSX.Element} The rendered BounceLoader component.
 */
var BounceLoader = function BounceLoader(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(BounceLoader$2, _objectSpread(_objectSpread({
    // @ts-ignore
    $size: size
  }, rest), {}, {
    children: [/*#__PURE__*/jsx(Dot, {
      // @ts-ignore
      $size: size
    }), /*#__PURE__*/jsx(Dot, {
      // @ts-ignore
      $size: size
    }), /*#__PURE__*/jsx(Dot, {
      // @ts-ignore
      $size: size
    })]
  }));
};
var BounceLoader$1 = BounceLoader;

export { BounceLoader$1 as default };
//# sourceMappingURL=BounceLoader.js.map
